import React from 'react';
import { Tag } from 'antd';
export var IncidentEventType;
(function (IncidentEventType) {
    IncidentEventType["Downtime"] = "Downtime";
})(IncidentEventType || (IncidentEventType = {}));
const incidentEventText = {
    [IncidentEventType.Downtime]: 'Downtime'
};
const incidentEventColor = {
    [IncidentEventType.Downtime]: 'red'
};
export const IncidentEventTypeTag = ({ eventType }) => React.createElement(Tag, { color: incidentEventColor[eventType] }, incidentEventText[eventType]);
